export const Bio = {
  name: "Shiva Shankar",
  roles: [
    "Frontend Developer ",
    "Software Engineer",
    "SharePoint Developer",
    "Electronics Engineer",
  ],
  description:
    "I am a dynamic and adaptable professional, driven by a relentless passion for learning and growth. As a Developer - I Software Engineering at UST, I bring a strong commitment to delivering excellence, a positive attitude, and a growth mindset to every challenge.",
  github: "https://github.com/ShivaShankarGoddumarri",
};

export const skills = [
  {
    title: "Web Development",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },

      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },

      {
        name: "TypeScript",
        image:
          "https://th.bing.com/th?id=OIP.kUorSTg4WAJvluB7R0BUegHaHa&w=250&h=250&c=8&rs=1&qlt=90&o=6&dpr=1.3&pid=3.1&rm=2",
      },

      {
        name: "Sharepoint",
        image:
          "https://th.bing.com/th?id=OIP.g7uX5AXrFcBQ1cAiCg24JQHaHa&w=250&h=250&c=8&rs=1&qlt=90&o=6&dpr=1.3&pid=3.1&rm=2",
      },

      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },

      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },

      {
        name: "SCSS",
        image:
          "https://th.bing.com/th?q=Scss+Icon.png&w=120&h=120&c=1&rs=1&qlt=90&cb=1&dpr=1.3&pid=InlineBlock&mkt=en-IN&cc=IN&setlang=en&adlt=moderate&t=1&mw=247",
      },

      // {
      //   name: "Material UI",
      //   image:
      //     "data:image/png;base64,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",
      // },

      {
        name: "Redux",
        image:
          "https://th.bing.com/th/id/R.8251fe76d7487a28b07603515b300964?rik=H7lrBp652zDaWg&riu=http%3a%2f%2fassets.stickpng.com%2fimages%2f5848309bcef1014c0b5e4a9a.png&ehk=N%2fi7UuvK4YyoLcxusdDEWeftPaGIfNJl2VmpTOtLt%2bA%3d&risl=&pid=ImgRaw&r=0",
      },

      {
        name: "Jest",
        image:
          "https://www.danielcornock.co.uk/assets/images/article-icons/jest.png",
      },

      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },

      {
        name: "Git",
        image:
          "https://tse1.mm.bing.net/th?id=OIP.CSOa8Mk8jL35E1_02q2spAAAAA&pid=Api&P=0&h=180",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
    ],
  },

  // {
  //   title: "Core Electronics",
  //   skills: [
  //     {
  //       name: "Product Design",
  //       image: "https://cdn-icons-png.flaticon.com/128/3852/3852813.png",
  //     },

  //     {
  //       name: "Embedded Systems",
  //       image: "https://cdn-icons-png.flaticon.com/128/5721/5721444.png",
  //     },

  //     {
  //       name: "Circuit Designing",
  //       image: "https://cdn-icons-png.flaticon.com/128/4645/4645248.png",
  //     },
  //   ],
  // },

  // {
  //   title: "Microsoft Office",
  //   skills: [
  //     {
  //       name: "Word",
  //       image:
  //         "https://logodownload.org/wp-content/uploads/2018/10/word-logo-8.png",
  //     },

  //     {
  //       name: "Excel",
  //       image:
  //         "https://logodownload.org/wp-content/uploads/2020/04/excel-logo-0.png",
  //     },

  //     {
  //       name: "Power Point Presentation",
  //       image:
  //         "https://logodownload.org/wp-content/uploads/2020/04/microsoft-powerpoint-logo-0.png",
  //     },
  //   ],
  // },

  // {
  //   title: "Creative Design",
  //   skills: [
  //     {
  //       name: "Canva",
  //       image:
  //         "https://github.com/ShivaShankarGoddumarri/User-Images/assets/96565316/846dceab-7768-4811-b13f-c27456e5323e",
  //     },

  //     {
  //       name: "Figma",
  //       image:
  //         "https://cdn.icon-icons.com/icons2/2699/PNG/512/figma_logo_icon_170157.png",
  //     },

  //     {
  //       name: "Picsart",
  //       image:
  //         "https://play-lh.googleusercontent.com/hexunszQESgaMxZdfuGvYdNnS6fRebRqW5lECqadoqlTL3fbJbLL6NKceHlQ58ALXcE",
  //     },

  //     {
  //       name: "Kinemaster",
  //       image:
  //         "https://cdn141.picsart.com/009b40e9-5c90-4dcc-8171-6ff04d177c95/392124013016211.png",
  //     },
  //   ],
  // },
];

export const experiences = [
  {
    id: 2,
    img: "https://mma.prnewswire.com/media/1422658/UST_Logo.jpg",
    role: "Developer - I Software Engineering",
    company: "UST",
    date: "Aug 2024 - Present",
    desc: "Working in a client location - Applied Materials",
    skills: [
      "React",
      "Javascript",
      "TypeScript",
      "Sharepoint",
      "HTML",
      "CSS",
      "SCSS",
    ],
  },

  {
    id: 1,
    img: "https://github.com/ShivaShankarGoddumarri/User-Images/assets/96565316/34b4ca41-be31-486c-8055-c55414c082a4",
    role: "Frontend Web Developer",
    company: "BeyInc",
    date: "Dec 2023 - July 2024",
    desc: "Domain : Web Development",

    skills: [
      "Javascript",
      "React",
      "Material UI",
      "HTML",
      "CSS",
      "Redux",
      "Git",
      "GitHub",
    ],
  },

  {
    id: 0,
    img: "https://tse4.mm.bing.net/th?id=OIP.uv1WkNpW_1mjufoqDIaQrwAAAA&pid=Api&P=0&h=180",
    role: "Graduate Engineer Trainee",
    company: "HCL Technologies",
    date: "Aug 2022 - Aug 2023",
    desc: "Domain : ERS-MMT-Transportation-AUTO-GBL_OEM",

    skills: ["C", "Embedded Systems", "CAN", "UDS"],
  },
];

export const education = [
  {
    id: 0,

    school: "Jawaharlal Nehru Technological University, Anantapur",
    date: "June 2018 - July 2022",
    degree: "Bachelor of Technology",
    branch: "Electronics and Communication Engineering",
  },

  {
    id: 1,

    school: "Sri Sai Krupa Junior College, Dharmavaram",
    date: "March 2016 - March 2018",
    degree: "Intermediate",
    branch: "MPC",
  },
  {
    id: 2,

    school: "Sri Gayathri English Medium High School, Dharmavaram",
    date: "March 2015 - March 2016",
    degree: "Class X",
    branch: "SSC",
  },
];

export const projects = [
  {
    id: 6,
    title: "Portfolio",
    date: "September 2023",
    description:
      "Portfolio is a web application and mobile app  which showcase all about my skills , experience , education and my projects",
    image:
      "https://github.com/ShivaShankarGoddumarri/User-Images/assets/96565316/1b431e7c-23d1-4181-8a80-3e66778521c6",
    tags: ["HTML", "CSS", "Java Script", "React"],
    category: "web app",
    github: "",
    webapp: "https://shiva-shankar-portfolio.vercel.app/",
  },

  {
    id: 0,
    title: "BeyInc",
    date: "December 2023 - Present",
    description:
      "This project is an innovative social media platform designed to facilitate connections between entrepreneurs, mentors, and investors. This platform aims to nurture startup ideas by providing a collaborative space where entrepreneurs can seek guidance, share their visions, and secure investment opportunities. By bridging the gap between startup enthusiasts and seasoned professionals, our platform fosters an environment conducive to business growth and innovation.",
    image:
      "https://github.com/ShivaShankarGoddumarri/User-Images/assets/96565316/0dceca9a-3d50-433d-ba7e-634ff5f828f7",
    tags: ["HTML", "CSS", "Java Script", "React", "Redux", "Material UI"],
    category: "web app",
    github: "",
    webapp: "https://www.beyinc.org/",
  },

  {
    id: 1,
    title: "Dr. Medicine",
    date: "September 2023",
    description:
      "Dr. Medicine is a web application, used to check the symptoms and get an advisable medicine who can cure their symptoms with specific medicine",
    image:
      "https://github.com/ShivaShankarGoddumarri/User-Images/assets/96565316/a65797ce-63e4-485a-84a9-04172f29085d",
    tags: ["React", "HTML", "CSS", "Java Script"],
    category: "web app",
    github: "https://github.com/ShivaShankarGoddumarri/Dr.Medicine",
    webapp: "https://dr-medicine-adviser.vercel.app/",
  },

  {
    id: 2,
    title: "Amazon Clone",
    date: "Aug 2023",
    description:
      "Amazon Clone is a web application designed to enhance my Frontend knowledge by cloning the Amazon Frontend",
    image:
      "https://github.com/ShivaShankarGoddumarri/User-Images/assets/96565316/8b34a415-7476-4edc-8aa8-3033d0cd308c",
    tags: ["HTML", "CSS"],
    category: "web app",
    github: "https://github.com/ShivaShankarGoddumarri/Amazon-Clone",
    webapp: "https://amazon-clone-pi-ten.vercel.app/",
  },

  {
    id: 3,
    title: "Self Core Projects",
    description: "I have included my top self core projects in this website",
    image:
      "https://github.com/ShivaShankarGoddumarri/User-Images/assets/96565316/fa59f6d2-809b-4bc5-9543-5d324888cddb",
    tags: ["React", "HTML", "CSS", "Java Script"],
    category: "Self Core Projects",
    github: "https://github.com/ShivaShankarGoddumarri/Self-Core-Projects",
    webapp: "https://self-core-projects.vercel.app/",
  },
  {
    id: 4,
    title: "Enigma 2K22",
    date: "Dec 2021 - Jan 2022",
    description:
      "Enigma-2k22 is a web application designed to streamline Registration management and enhance productivity for the departmental fest. It provides a user-friendly interface for students to register for the events and fest related posters and designs.",
    image:
      "https://github.com/ShivaShankarGoddumarri/User-Images/assets/96565316/ffbffd9d-f645-430d-89b8-510073f98c97",
    tags: ["HTML", "CSS", "SCSS"],
    category: "web app",
    github: "https://github.com/ShivaShankarGoddumarri/Enigma-2k22",
    webapp: "https://enigma-2k22.vercel.app/",
  },
];
